import { Text } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export default function ListLabel(props: PropsWithChildren<{}>) {
	return (
		<Text textTransform="uppercase" fontSize="xs" fontWeight="700" color="gray.700" mx="1.3rem" mt="4" mb="3">
			{props.children}
		</Text>
	);
}
